import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // React.StrictMode OR React.Suspense
  <React.Suspense>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </React.Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
